<template>
  <b-row :class="black ? 'fp_bloc_bl' : 'fp_bloc'">
    <div class="title_bloc">Investissement (€)</div>
    <div class="fp_bloc_content">
      <b-button v-on:click="amountDown">-</b-button>
      <b-form-input
        class="customFormControl"
        placeholder="Enter your name"
        type="number"
        v-model="count"
        @input="handleAmount($event)"
      />
      <b-button v-on:click="amountUp">+</b-button>
    </div>
  </b-row>
</template>
<script>
export default {
  props: ["amount", "black"],
  data() {
    return {
      count: this.amount
    };
  },
  watch: {
    amount(val) {
      this.count = val;
    }
  },
  methods: {
    handleAmount(e) {
      this.count = parseInt(e);
    },
    amountUp() {
      this.count += 1000;
    },
    amountDown() {
      if (this.count > 0) {
        this.count -= 1000;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./resources/sass/_variables.scss";

.fp_bloc_bl {
  width: 60%;
  margin: auto;
  width: 60%;
  margin: auto;
  padding: 15px;
  margin-top: 20px;
  margin-bottom: 50px;
  justify-content: center;

  background: #333436 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 33px;
  opacity: 1;

  // @extend .mf_bg;
  // padding-bottom: 0.5rem;

  .fp_bloc_content {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    width: 100%;
  }

  .title_bloc {
    margin-bottom: 10px;
    margin-top: 10px;
    color: var(--unnamed-color-ffffff);
    text-align: center;
    letter-spacing: NaNpx;
    color: $mf_ft_color_white;
    opacity: 1;
  }

  button {
    background: #242527 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    opacity: 0.6;
    &:hover {
      background: $bg_color;
    }
  }
}

.customFormControl {
  color: $purple_color !important;
  font-weight: bold;
  font-size: 1.5em !important;
  background: transparent !important;
  border: none !important;
  text-align: center;
}
</style>